import { render } from "./YagPompasi.vue?vue&type=template&id=ca907e7c"
import script from "./YagPompasi.vue?vue&type=script&lang=js"
export * from "./YagPompasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__